import { useEffect, useState } from 'react'
import { supabase } from '../../../lib/supabase'
import AdminLayout from '../components/AdminLayout'
import MembersTable from './components/MembersTable'
import MemberFilters from './components/MemberFilters'
import LoadingSpinner from '../../../components/LoadingSpinner'

const CLUB_ID = 'a0000000-0000-0000-0000-000000000001'

export default function AdminMembers() {
  const [members, setMembers] = useState([])
  const [chapters, setChapters] = useState([])
  const [filtered, setFiltered] = useState([])
  const [loading, setLoading] = useState(true)

  const fetchMembers = async () => {
    const { data } = await supabase
      .from('supporters').select('*, chapters(name)')
      .eq('club_id', CLUB_ID).order('joined_at', { ascending: false })
    if (data) { setMembers(data); setFiltered(data) }
  }

  const fetchChapters = async () => {
    const { data } = await supabase
      .from('chapters').select('*').eq('club_id', CLUB_ID).order('name')
    if (data) setChapters(data)
  }

  useEffect(() => {
    const fetchAll = async () => {
      await Promise.all([fetchMembers(), fetchChapters()])
      setLoading(false)
    }
    fetchAll()
  }, [])

  return (
    <AdminLayout>
      <div className="mb-6 lg:mb-8 flex justify-between items-center gap-4">
        <div>
          <h1 className="text-2xl lg:text-4xl font-black uppercase tracking-tight mb-2 text-gray-900 dark:text-white">Members</h1>
          <p className="text-gray-500 text-sm">{members.length} total supporters</p>
        </div>
        <button
          onClick={() => {
            const csv = [
              ['Member ID', 'Name', 'Email', 'Chapter', 'Status', 'Joined'],
              ...members.map((m) => [m.membership_id, m.full_name, m.email, m.chapters?.name || 'N/A', m.status, new Date(m.joined_at).toLocaleDateString()]),
            ].map((row) => row.join(',')).join('\n')
            const blob = new Blob([csv], { type: 'text/csv' })
            const url = URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = 'members.csv'
            a.click()
          }}
          className="bg-green-600 hover:bg-green-700 text-white px-4 sm:px-6 py-3 font-bold uppercase tracking-widest text-xs sm:text-sm transition-colors whitespace-nowrap"
        >
          Export CSV
        </button>
      </div>
      <MemberFilters members={members} setFiltered={setFiltered} />
      {loading ? (
        <LoadingSpinner fullScreen message="Loading members..." />
      ) : (
        <MembersTable members={filtered} chapters={chapters} onRefresh={fetchMembers} />
      )}
    </AdminLayout>
  )
}